import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Index from '../views/index.vue'
import OverallScheme from '../views/overallScheme.vue'
import SchemeDetail from '../views/schemeDetail.vue'
import Goods from '../views/goods.vue'
import GoodsDetail from '../views/goodsDetail.vue'
import Brand from '../views/brand.vue'
import BrandDetail from '../views/brandDetail.vue'
import Case from '../views/case.vue'
import CaseDetail from '../views/caseDetail.vue'
import MyScheme from '../views/myScheme.vue'
import MySchemeDetail from '../views/mySchemeDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect:'/index.html',
  },
  {
    path: '/index.html',
    component: Home,
    children: [{
      path: '',
      component: Index,
      name: 'Index',
      meta: {
        title: '首页',
      }
    }]
  },
  {
    path: '/overallScheme.html',
    component: Home,
    children: [{
      path: '',
      component: OverallScheme,
      name: 'OverallScheme',
      meta: {
        title: '整装方案',
      }
    }]
  },
  {
    path: '/schemeDetail',
    component: Home,
    children: [{
      path: '',
      component: SchemeDetail,
      name: 'SchemeDetail',
      meta: {
        title: '整装方案',
      }
    }]
  },
  {
    path: '/goods.html',
    component: Home,
    children: [{
      path: '',
      component: Goods,
      name: 'Goods',
      meta: {
        title: '选商品',
      }
    }]
  },
  {
    path: '/goodsDetail',
    component: Home,
    children: [{
      path: '',
      component: GoodsDetail,
      name: 'GoodsDetail',
      meta: {
        title: '选商品',
      }
    }]
  },
  {
    path: '/brand.html',
    component: Home,
    children: [{
      path: '',
      component: Brand,
      name: 'Brand',
      meta: {
        title: '找品牌',
      }
    }]
  },
  {
    path: '/brandDetail',
    component: Home,
    children: [{
      path: '',
      component: BrandDetail,
      name: 'BrandDetail',
      meta: {
        title: '找品牌',
      }
    }]
  },
  {
    path: '/case.html',
    component: Home,
    children: [{
      path: '',
      component: Case,
      name: 'Case',
      meta: {
        title: '看案例',
      }
    }]
  },
  {
    path: '/caseDetail',
    component: Home,
    children: [{
      path: '',
      component: CaseDetail,
      name: 'CaseDetail',
      meta: {
        title: '看案例',
      }
    }]
  },
  {
    path: '/myScheme.html',
    component: Home,
    children: [{
      path: '',
      component: MyScheme,
      name: 'MyScheme',
      meta: {
        title: '我的方案',
      }
    }]
  },
  {
    path: '/mySchemeDetail',
    component: Home,
    children: [{
      path: '',
      component: MySchemeDetail,
      name: 'MySchemeDetail',
      meta: {
        title: '我的方案',
      }
    }]
  },
]

const router = new VueRouter({
  routes
})

export default router
